var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-section",
    { attrs: { header: "Tracking" } },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "start", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { outlined: "", elevation: "4" }
                            },
                            [
                              _c("v-simple-table", {
                                staticClass: "px-2 pb-2 input-table",
                                attrs: { dense: "", "fixed-header": "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function() {
                                      return [
                                        _c("tbody", [
                                          _c(
                                            "tr",
                                            {
                                              ref: "errorMessageRow",
                                              staticClass: "error-message-row"
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "col-12" },
                                                [
                                                  _c(
                                                    "v-alert",
                                                    {
                                                      attrs: { type: "warning" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          The tag you have provided is not valid.\n                        "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("td")
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "tr",
                                            {
                                              staticClass: "tracker-input-row"
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "col-1" },
                                                [
                                                  _c("v-textarea", {
                                                    ref: "trackerInput",
                                                    staticClass:
                                                      "tracker-input",
                                                    attrs: {
                                                      placeholder:
                                                        "Paste your tracker here"
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.onTagChanged(
                                                          _vm.currentTrackerInput
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentTrackerInput
                                                          .tag,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentTrackerInput,
                                                          "tag",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentTrackerInput.tag"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "col-1 text-right"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        title:
                                                          "Add/Update tracker",
                                                        icon: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addThirdPartyTrackerRow()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-arrow-right-thick"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.replaceableTags(
                                            _vm.currentTrackerInput
                                          ).length > 0
                                            ? _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "col-12" },
                                                  [
                                                    _c(
                                                      "v-container",
                                                      {
                                                        staticClass:
                                                          "macro-container"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Foreign macros detected click to replace: "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-2"
                                                          },
                                                          _vm._l(
                                                            _vm.replaceableTags(
                                                              _vm.currentTrackerInput
                                                            ),
                                                            function(tag) {
                                                              return _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "ml-1 mr-1 mb-2",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.replaceTag(
                                                                        tag.key,
                                                                        _vm.currentTrackerInput
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        tag.key
                                                                      ) +
                                                                      " => " +
                                                                      _vm._s(
                                                                        tag.value
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("td")
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("v-simple-table", {
                                staticClass: "px-2 pb-2",
                                attrs: { dense: "", "fixed-header": "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function() {
                                      return [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { staticClass: "text-center" },
                                              [_vm._v("Tag")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { staticClass: "text-center" },
                                              [_vm._v("Type")]
                                            ),
                                            _vm._v(" "),
                                            _c("th")
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.local, function(item) {
                                              return _vm.local.length > 0
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "added-tracker-row",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.editThirdPartyTracker(
                                                            $event,
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tracker-row-tag"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(item.tag)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table-type-container"
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "type-change-button",
                                                                attrs: {
                                                                  title:
                                                                    "Previous type",
                                                                  icon: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeType(
                                                                      $event,
                                                                      item,
                                                                      false
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-arrow-left-drop-circle-outline"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.getTagTypeName(
                                                                    item
                                                                  )
                                                                ) +
                                                                "\n                          "
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "type-change-button",
                                                                attrs: {
                                                                  title:
                                                                    "Next type",
                                                                  icon: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeType(
                                                                      $event,
                                                                      item,
                                                                      true
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-arrow-right-drop-circle-outline"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeThirdPartyTracker(
                                                                    $event,
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-delete"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }),
                                            _vm._v(" "),
                                            _vm.local.length <= 0
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "3" } },
                                                    [
                                                      _vm._v(
                                                        "No trackers added yet"
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }